import { type TokenGroup } from "../../types";

export const altitude = {
  name: "altitude",
  variables: {
    "1": { type: "color", value: { dark: "#0a111d", light: "#fcfdff" } },
    "2": { type: "color", value: { dark: "#0e1827", light: "#f6f9ff" } },
    "3": { type: "color", value: { dark: "#0d254c", light: "#eaf3ff" } },
    "4": { type: "color", value: { dark: "#0d2f67", light: "#dbebff" } },
    "5": { type: "color", value: { dark: "#133a7a", light: "#c9e1ff" } },
    "6": { type: "color", value: { dark: "#1b458b", light: "#b4d4ff" } },
    "7": { type: "color", value: { dark: "#2352a0", light: "#9bc1ff" } },
    "8": { type: "color", value: { dark: "#2860bb", light: "#77a8f9" } },
    "9": { type: "color", value: { dark: "#0563e9", light: "#0563e9" } },
    "10": { type: "color", value: { dark: "#255cb8", light: "#0056d1" } },
    "11": { type: "color", value: { dark: "#83b7ff", light: "#1061dd" } },
    "12": { type: "color", value: { dark: "#cfe3ff", light: "#0f2f65" } },
  },
} as const satisfies TokenGroup<"altitude">;
